import { useEffect, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Modal } from './Modal'
import { HeaderModal } from './Header'
import { Body } from './Body'
import { FooterModal } from './Footer'
import closeIcon from 'assets/images/close-icon.svg';
import modalBgShade from "../../../assets/images/bg-modal-shade.svg";
import allImgPaths from 'assets/images';
import CustomCheckBox from 'components/CustomCheckBox';
import { getAttendeeList, getEventVendorList, resendEmails, sendEmails } from 'services/event';
import { cloneDeep } from 'lodash';
import { ExistingSettingMemberLoader } from 'components/loaders';
import CustomDropdown from '../dropdown/Dropdown';
import CustomSelect from '../CustomSelect';
import { format } from 'date-fns';
import Toast from '../Toast';

const pageOptions = [
    10, 50, 100, 500, 1000
]

const EmailVendorListModal = ({ data: templateData, ids, setShowListModal, type, categoryData }: any) => {
    const [data, setData] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [allSelected, setAllSelected] = useState(false)
    const [searchText, setSearchText] = useState('');
    const [perPage, setPerPage] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [finalPage, setFinalPage] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalEmailSent, setTotalEmailSent] = useState(0)
    const [showDismissBox, setShowDismissBox] = useState(false);
    const [initAttendeePayload, setInitAttendeePayload] = useState<any>({
        event_id: ids.eventId,
        rag_id: ids?.ragId,
        ...categoryData,
        perPage: perPage,
        page: currentPage
    })
    const [originalData, setOriginalData] = useState<any>([])

    const [optionsSelected, setOptionsSelected] = useState(null)
    const [currentSort, setCurrentSort] = useState(0)
    const [btnDisabled, setBtnDisabled] = useState(true);

    const optionsList = [
        { value: 'yes', label: 'Yes, already included.' },
        { value: 'no_other', label: 'No, I want other vendors for that.' },
        { value: 'no_missed', label: 'No, I missed. Can we include now?' }
    ]
    const [sortOrder, setSortOrder] = useState('asc');

    useEffect(() => {
        fetchList(initAttendeePayload)
    }, [])

    const fetchList = async (attendeePayload: any) => {
        // console.log({ attendeePayload })
        setLoading(true)

        try {
            const { data } = await getEventVendorList(attendeePayload)
            const updatedData = setListData(data?.data)
            setTotalData(data?.length)
            setCurrentPage(attendeePayload.page)
            setFinalPage(Math.ceil(data?.length / attendeePayload.perPage))
            console.log({ attendeeData: updatedData })
            setData(updatedData)
            setOriginalData(cloneDeep(updatedData))
            setLoading(false)
        } catch (error) {
            setLoading(false)
            setListData([])
        }
    }

    const setListData = (data: any[]) => {
        if (data?.length) {
            let totalSent = 0
            data.map((dt: any) => {
                const currentTemplateStatus = (dt?.emailStatus || []).find((es: any) => JSON.stringify(es?.ragId) == JSON.stringify(ids?.ragId)) || null;
                if (currentTemplateStatus) {
                    totalSent = totalSent + currentTemplateStatus?.timeline?.length;
                    if (currentTemplateStatus?.timeline?.length > 0) {
                        let lastTimeLine = currentTemplateStatus.timeline[0];
                        dt['lastStatus'] = lastTimeLine?.status || 'no'
                        dt['sentTime'] = lastTimeLine?.sentTime || null
                    }
                } else {
                    dt['lastStatus'] = 'no'
                    dt['sentTime'] = null
                }
                dt['selected'] = false
            });

            if (totalSent > 0) setShowDismissBox(true)
            setTotalEmailSent(totalSent)

            return data
        }
        return []
    }

    const handleSelection = (id: string, isChecked: boolean) => {
        let clonedData: any[] = cloneDeep(data);
        if (id != 'all') {
            const index = clonedData.findIndex((cd: any) => JSON.stringify(cd._id) == JSON.stringify(id));
            if (index > -1) {
                clonedData[index]['selected'] = isChecked;
            }

            // Set top checkbox status
            if (!isChecked) setAllSelected(false)

            const allSelected = clonedData.every((cd: any) => cd.selected);
            if (allSelected) setAllSelected(true)

        } else {
            clonedData = clonedData.map((cd: any) => ({ ...cd, selected: isChecked }))
            setAllSelected(isChecked)
        }

        setData(clonedData);

        if (clonedData.some((cd: any) => cd.selected)) {
            setBtnDisabled(false)
        } else {
            setBtnDisabled(true)
        }
    }

    const handleSearch = async (fromClose = false) => {
        const text = fromClose ? '' : (searchText ? searchText.trim() : '');
        const clonedAttendeePayload: any = cloneDeep(initAttendeePayload);
        clonedAttendeePayload['query'] = text;
        setInitAttendeePayload(clonedAttendeePayload)
        await fetchList(clonedAttendeePayload)
    }

    const handlePageChange = async (page: number) => {
        if (page > 0) {
            const clonedAttendeePayload: any = cloneDeep(initAttendeePayload);
            clonedAttendeePayload['page'] = page;

            setInitAttendeePayload(clonedAttendeePayload)
            await fetchList(clonedAttendeePayload)
        }
    }

    const handleSort = (type: string) => {
        const sortedData = [...data].sort((a, b) => {
            if (type == 'sentTime') {
                const dateA: any = new Date(a.sentTime);
                const dateB: any = new Date(b.sentTime);
                if (sortOrder === 'asc') {
                    return dateA - dateB;
                } else {
                    return dateB - dateA;
                }
            } else {
                if (sortOrder === 'asc') {
                    return a[type].localeCompare(b[type]);
                } else {
                    return b[type].localeCompare(a[type]);
                }
            }
        });
        setData(sortedData);
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    };

    const handlePerPageChange = async (e: any) => {
        const value = +e.target.value;
        if (value != perPage) {
            const clonedAttendeePayload: any = cloneDeep(initAttendeePayload);
            clonedAttendeePayload['perPage'] = value;
            clonedAttendeePayload['page'] = 1;
            setInitAttendeePayload(clonedAttendeePayload)
            await fetchList(clonedAttendeePayload);

            setPerPage(value)
        }
    }

    const send = async () => {
        const { eventId, ragId } = ids;
        const receivers = data.filter((dt: any) => dt?.selected).map((dt: any) => dt?._id);

        if (receivers?.length > 0) {
            const payload = { ragId, receivers, ...categoryData }

            await resendEmails(eventId, payload)
            setShowListModal(false)

            Toast.success('Email', 'Emails sent successfully')
        }
    }

    return (
        <div>
            <Modal className={"modal-wrapper max-w-[1440px]"} isShow={setShowListModal}>
                <div>
                    <HeaderModal title={''} isShowHeader={true} className="modal-header">
                        <div className="flex items-center justify-between py-4 px-4 border-b border-[#EAECF0]">
                            <div className="flex items-center gap-x-2">
                                <img src={allImgPaths.sendIcon4} alt="" />
                                <h2 className="text-xl text-[#101828] font-interSemiBold leading-none">Send to</h2>
                            </div>
                            {/* Close Icon */}
                            <img
                                className="modal-close modal-toggle cursor-pointer hover:bg-[#f2f4f7] rounded w-5 p-1 mr-4"
                                id="modal-toggle"
                                src={closeIcon}
                                onClick={() => { setShowListModal(false) }}
                                alt="close icon"
                            />
                        </div>
                    </HeaderModal>

                    <Body title="" isShowBody={true} className="modal-body px-6 flex gap-x-4 max-h-[calc(100vh_-_326px)] pt-7">
                        <div className="bg-[#F9FAFB] py-4 px-2 w-[326px]">
                            {/* Dismiss Box */}
                            {
                                showDismissBox &&
                                <div className="mb-5 border border-[#D0D5DD] rounded-xl py-4 px-4 bg-white shadow-sm flex flex-shrink-0 items-start gap-x-2.5">

                                    <img src={allImgPaths.alertIconSaffron} alt="" />

                                    <div className="">
                                        <p className='text-sm font-interMedium text-[#344054] pb-1'>Just to let you know you have already sent out this invitation earlier</p>
                                        <p className='text-sm text-[#475467] pb-2'>
                                            {/* You have sent out this email invitation to 100 attendees on May 31, 2024 */}
                                            You have sent out this email invitation to {totalEmailSent} attendees
                                        </p>
                                        <button
                                            className='text-[#475467] text-sm font-interMedium'
                                            onClick={() => setShowDismissBox(false)}>
                                            Dismiss
                                        </button>
                                    </div>

                                </div>
                            }

                            {/* card will render here.. */}
                            {
                                <div className="">
                                    <div className='border border-[#EAECF0] px-2 py-2 rounded-[10px] bg-[#fff] w-[280px] flex-shrink-0 hover:shadow-xl'>
                                        <div className="relative">

                                            <div className="rounded-tl-lg rounded-tr-lg border border-dashed border-[#EAECF0] pl-4 pt-1">
                                                <h5 className="text-lg text-[#344054] truncate max-w-52 font-interMedium">
                                                    {templateData?.pinData?.title || 'No Title'}
                                                </h5>
                                                <h6 className="text-sm text-[#344054] pb-2 truncate max-w-52">
                                                    {templateData?.pinData?.selectedOption || 'No Subheading'}
                                                </h6>
                                            </div>
                                            <div className='h-[190px] rounded-[10px] mb-2.5 group'>
                                                <div className='flex items-center justify-between'>
                                                    {
                                                        totalEmailSent > 0 &&
                                                        <div className={`items-center gap-x-1.5 bg-[#ecfcf3] py-5.5 px-3 mt-12 rounded-lg text-[#3f7f52] absolute top-2 right-2 cursor-pointer w-fit`}>
                                                            <span>Sent to {totalEmailSent} attendees</span>
                                                        </div>
                                                    }

                                                    <img
                                                        className={`rounded-bl-[10px] rounded-br-[10px] w-full h-full object-cover mb-2`}
                                                        src={data?.imageUrl ? data.imageUrl : allImgPaths.EmailTemplateImage}
                                                        alt=''
                                                    />
                                                </div>
                                            </div>
                                            <h5 title={data?.title} className={`mt-4 text-[#101828] font-interSemiBold text-[17px] line-clamp-2 max-w-72 px-0.5 mb-2 h-12`}>
                                                {templateData?.title || 'No title'}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        <div className="flex-1">
                            <div className='px-6 w-full'>
                                <div className='flex items-center'>
                                    <div className="border border-[#D0D5DD] rounded-lg w-80 py-2 px-3.5 flex items-center gap-x-2 mb-6">
                                        <img src={allImgPaths.searchIcon} alt="search" />
                                        <input
                                            className="w-full"
                                            placeholder="Name, Email"
                                            type="text"
                                            onChange={(e) => setSearchText(e.target.value)}
                                            value={searchText}
                                        />
                                        {
                                            searchText &&
                                            <img
                                                className='cursor-pointer'
                                                src={allImgPaths.closeIconRed}
                                                alt=""
                                                onClick={(e) => {
                                                    setSearchText('');
                                                    handleSearch(true)
                                                }}
                                            />
                                        }
                                    </div>
                                    <button
                                        className={`submit-btn-blue !px-[15px] ml-5 mb-6 !text-sm hover:bg-[#120693] ${searchText ? '' : 'button-disabled'}`}
                                        onClick={() => handleSearch(false)}
                                    >
                                        Search
                                    </button>
                                </div>

                                {loading && <ExistingSettingMemberLoader />}
                                {
                                    !loading && data && data?.length > 0 &&
                                    <>
                                        <div className="custom-table-grid-attendees-list bg-[#F9FAFB] rounded-tl-lg rounded-tr-lg border-b-0 border border-[#EAECF0]">
                                            <div className='flex items-center gap-x-3 py-3 px-6 checkbox-alignment mt-1'>
                                                <CustomCheckBox
                                                    label={''}
                                                    name={'all'}
                                                    checked={allSelected}
                                                    onChange={handleSelection}
                                                />
                                                <span className="font-interMedium text-sm text-[#475467] flex items-center gap-x-1">
                                                    Name
                                                    <img onClick={() => handleSort('name')} className='w-4 cursor-pointer' src={allImgPaths.sortIcon} alt="" />
                                                </span>
                                            </div>

                                            <div className='flex items-center gap-x-3 py-3 px-6'>
                                                <span className="font-interMedium text-sm text-[#475467] flex items-center gap-x-1">
                                                    Email Adresss
                                                    <img onClick={() => handleSort('email')} className='w-4 cursor-pointer' src={allImgPaths.sortIcon} alt="" />
                                                </span>
                                            </div>

                                            <div className='flex items-center gap-x-3 py-3 px-6'>
                                                <span className="font-interMedium text-sm text-[#475467] flex items-center gap-x-1">
                                                    Last Status
                                                    {/* <img onClick={() => handleSort('lastStatus')} className='w-4 cursor-pointer' src={allImgPaths.sortIcon} alt="" /> */}
                                                </span>
                                            </div>

                                            <div className='flex items-center gap-x-3 py-3 px-6'>
                                                <span className="font-interMedium text-sm text-[#475467] flex items-center gap-x-1">
                                                    Time
                                                    <img onClick={() => handleSort('sentTime')} className='w-4 cursor-pointer' src={allImgPaths.sortIcon} alt="" />
                                                </span>
                                            </div>
                                        </div>

                                        <div className="border border-[#EAECF0] transparent-scrollbar rounded-bl-lg rounded-br-lg">
                                            <div className="rounded-bl-md rounded-br-md max-h-[408px] overflow-y-auto">
                                                {
                                                    data?.length > 0 && data.map((dt: any, index: number) => (
                                                        <div key={index} className="custom-table-grid-attendees-list border-b last:border-b-0 border-[#eee]">
                                                            <div className="flex items-center gap-x-4 py-3 px-6 checkbox-alignment mt-1">
                                                                <CustomCheckBox
                                                                    label={''}
                                                                    name={dt._id}
                                                                    checked={dt.selected}
                                                                    onChange={handleSelection}
                                                                />

                                                                <div className="flex gap-x-3 items-center">
                                                                    <p className='text-[#101828] text-sm font-interMedium'>
                                                                        {dt?.name || 'No Name'}
                                                                    </p>
                                                                </div>
                                                            </div>

                                                            <div className="py-3 px-6 flex items-center">
                                                                <span className='text-base text-[#151719]'>
                                                                    {dt?.email || '-'}
                                                                </span>
                                                            </div>

                                                            <div className="py-3 px-7 flex items-center">
                                                                {
                                                                    dt?.lastStatus == 'no' &&
                                                                    <span className='text-sm text-[#d92c21] border border-[#cb7971] bg-[#fef3f2] rounded px-2.5 py-0.5 flex items-center gap-x-2 font-interMedium cursor-pointer'>
                                                                        <img className='w-2.5' src={allImgPaths.closeIconRed} alt="" />
                                                                        No
                                                                    </span>
                                                                }
                                                                {
                                                                    dt?.lastStatus == 'sent' &&
                                                                    <span className='text-sm text-[#1e60d3] border border-[#a8d9fb] rounded px-1.5 py-0.5 bg-[#eef8ff] font-interMedium cursor-pointer'>
                                                                        Sent
                                                                    </span>
                                                                }
                                                                {
                                                                    dt?.lastStatus == 'failed' &&
                                                                    <span className='text-sm text-[#d92c21] border border-[#cb7971] bg-[#fef3f2] rounded px-2.5 py-0.5 flex items-center gap-x-2 font-interMedium cursor-pointer'>
                                                                        <img className='w-2.5' src={allImgPaths.closeIconRed} alt="" />
                                                                        Failed
                                                                    </span>
                                                                }
                                                            </div>

                                                            <div className="py-3 px-6 flex items-center">
                                                                <span className='text-base text-[#151719]'>
                                                                    {dt?.sentTime ? format(dt?.sentTime, 'dd MMMM yyyy hh:mm a') : '-'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                        {/* Pagination Box */}
                                        <div className="flex w-full items-center mt-3">
                                            <div>
                                                <select
                                                    value={perPage}
                                                    onChange={handlePerPageChange}
                                                    className='mr-5 border border-[#ccc] px-3 py-1.5 rounded-md' id="numberDropdown" name="numberDropdown">
                                                    {
                                                        pageOptions.map((po: any, index: number) => (
                                                            <option value={po} key={index}>
                                                                {po}
                                                            </option>
                                                        ))
                                                    }
                                                </select>
                                            </div>

                                            <div className="flex items-center gap-x-1">
                                                <span className='text-sm text-[#344054] font-interMedium'>Page</span>
                                                <span className='text-sm text-[#344054] font-interMedium'>{currentPage}</span>
                                                <span className='text-sm text-[#344054] font-interMedium'>of</span>
                                                <span className='text-sm text-[#344054] font-interMedium'>
                                                    {finalPage}
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1.5">
                                                {
                                                    (currentPage != 1 || currentPage == finalPage) && totalData > perPage &&
                                                    <img
                                                        className='cursor-pointer'
                                                        src={allImgPaths.pagiLeftBtn}
                                                        alt=""
                                                        onClick={() => handlePageChange(currentPage - 1)} />
                                                }
                                                {
                                                    currentPage != finalPage &&
                                                    <img
                                                        className='cursor-pointer'
                                                        src={allImgPaths.pagiRightBtn}
                                                        alt=""
                                                        onClick={() => handlePageChange(currentPage + 1)} />
                                                }
                                            </div>
                                        </div>
                                        {/* <p>current page {currentPage}</p>
                                        <p>final page {finalPage}</p>
                                        <p>Total data {totalData}</p>
                                        <p>Per page {perPage}</p> */}
                                    </>
                                }
                                {
                                    !loading && !data?.length &&
                                    <div className='ml-3'>
                                        <h3>No Attendees Available</h3>
                                    </div>
                                }
                            </div>

                            {/* Option box */}
                            {/* <div className="px-6 mt-5">
                                <div className="rounded-lg bg-[#F9FAFB] px-4 py-4 flex-1 border border-[#E4E7EC]">
                                    <p className='font-interMedium text-[#475467] mb-2'>This vendor offers other secondary services as well. Have you included these in the RFP?</p>

                                    <div className="flex gap-1.5 flex-wrap mb-5">
                                        <span className='text-[#344054] font-interMedium text-sm flex gap-x-1 items-center border-[#EAECF0] bg-white rounded-[100px] py-1 px-2.5 border'>
                                            <img src={allImgPaths.fbIcon} alt="" />
                                            F&B
                                        </span>

                                        <span className='text-[#344054] font-interMedium text-sm flex gap-x-1 items-center border-[#EAECF0] bg-white rounded-[100px] py-1 px-2.5 border'>
                                            <img src={allImgPaths.decoreIcon} alt="" />
                                            Decor & Rental
                                        </span>
                                    </div>

                                    <div className="">
                                        <p className='text-sm text-[#344054] font-interMedium mb-1.5'>Options</p>
                                        <CustomSelect
                                            options={optionsList}
                                            onChange={() => { }}
                                            className="border border-[#D0D5DD] rounded-lg w-1/2 send-mail"
                                        />
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </Body>

                    <FooterModal title="" isShowFooter={true} className="modal-footer pb-6 px-6 pt-8">
                        <div className="flex justify-end gap-x-3">
                            <button
                                className='cancle-btn-blue !px-[15px] !text-sm '
                                onClick={() => { setShowListModal(false) }}>
                                Cancel
                            </button>
                            <button
                                className={`submit-btn-blue !px-[15px] !text-sm ${btnDisabled ? 'button-disabled' : ''}`}
                                onClick={send}
                                disabled={btnDisabled}
                            >
                                Send
                            </button>
                        </div>
                    </FooterModal>
                </div>
            </Modal >
        </div >
    )
}

export default EmailVendorListModal